import React from 'react';
import './ButtomNavigationBar.css';
import constants from '../../constants/constants';
import LogoutTwoToneIcon from '@mui/icons-material/LogoutTwoTone';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import EmojiEventsTwoToneIcon from '@mui/icons-material/EmojiEventsTwoTone';
import ScoreboardTwoToneIcon from '@mui/icons-material/ScoreboardTwoTone';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';

const NAV_TABS = [
    {
        label: constants.TABS.LOGOUT_LABEL,
        value: constants.TABS.LOGOUT_VALUE,
        icon: <LogoutTwoToneIcon />,
        variant: 'logout',
    },
    {
        label: constants.TABS.ADD_MATCH_LABEL,
        value: constants.TABS.ADD_MATCH_VALUE,
        icon: <AddCircleOutlineRoundedIcon />,
        variant: 'add',
    },
    {
        label: constants.TABS.CHAT_LABEL,
        value: constants.TABS.CHAT_VALUE,
        icon: <ChatBubbleOutlineRoundedIcon />,
        variant: 'chat',
        requiresChat: true,
    },
    {
        label: constants.TABS.RESULTS_LABEL,
        value: constants.TABS.RESULTS_VALUE,
        icon: <ScoreboardTwoToneIcon />,
        variant: 'default',
    },
    {
        label: constants.TABS.TABLE_LABEL,
        value: constants.TABS.TABLE_VALUE,
        icon: <EmojiEventsTwoToneIcon />,
        variant: 'default',
    },
    {
        label: constants.TABS.PROFILE_LABEL,
        value: constants.TABS.PROFILE_VALUE,
        icon: <AccountCircleOutlinedIcon />,
        variant: 'default',
    },
];

function BottomNavigationBar({ tabValue, changeTabValue, isChatAvailable }) {
    const tabs = NAV_TABS.filter((tab) => !tab.requiresChat || isChatAvailable);

    return (
        <nav className="top-navigation-container">
            <div className="nav-bar">
                {tabs.map((tab) => {
                    const isActive = tabValue === tab.value;
                    return (
                        <button
                            key={tab.value}
                            className={`nav-tab nav-tab--${tab.variant} ${isActive ? 'nav-tab--active' : ''}`}
                            onClick={(e) => changeTabValue(e, tab.value)}
                            aria-label={tab.label}
                        >
                            <span className="nav-tab__icon">{tab.icon}</span>
                            <span className="nav-tab__label">{tab.label}</span>
                        </button>
                    );
                })}
            </div>
        </nav>
    );
}

export default BottomNavigationBar;
